﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            userNotificationIds: Array
        }
    }

    static get targets() {
        return ["badge"];
    }

    static get outlets() {
        return ["user-notifications"]
    }

    connect() {
        this.badgeTargets.forEach(bt => bt.style.transform = "");
    }

    acknowledged(e) {
        e.preventDefault();
        this.element.remove();

        this.userNotificationIdsValue.forEach(uni => {
            this.userNotificationsOutlet.markAsReadFromExternalSource(uni);
        });
    }
}